<template>
	<lv-column-text :align="align"
					:link="link"
					:row="showRow"
					:row-index="rowIndex"
					:field="field"
					:editable="lv_editable"
					:data-type="dataType"
					:tooltip="tooltip">
		<slot :row="row" :rowIndex="rowIndex" :align="align" :field="field" :editable="lv_editable">
			<div :class="classes" :style="contentStyles">
				<link-button type="none"
							 class="link-table-column-tree-expand-icon"
							 icon="link-icon-down"
							 iconOnly
							 :clickOutline="false"
							 @click.native.stop.prevent="treeUtils.handler.clickExpandIcon($event,row.id)"/>
				<link-check-all
					label=""
					class="link-table-column-tree-checkbox"
					v-if="showCheckbox && !!tableNode"
					:status="{check:'all',uncheck:'none',minus:'some'}[tableNode.checkStatus]"
					:disabled="!tableNode.isCheckable"
					@click="treeUtils.handler.clickCheckbox($event,row.id)"
				/>
				<div class="link-table-column-tree-item-text">
					<template v-if="!!col.colRef && !!col.colRef().$parent.$scopedSlots.treeContent">
						<lv-scope-slot :scopeSlotFunc="col.colRef().$parent.$scopedSlots.treeContent" :data="scopeSlotData"/>
					</template>
					<template v-else>
						{{!!col.field?showRow[col.field]:''}}
					</template>
				</div>
			</div>
		</slot>
	</lv-column-text>
</template>

<script>
	import LvColumnText from "../lv-column-text";
	import {ColumnItemMixin} from "../mixins";
	import {TableMark} from "../../table/utils/TableMark";
	import LvScopeSlot from "../../render/lv-scope-slot";
	import LinkCheckAll from "../../radio/link-check-all";

	export default {
		name: "link-table-column-tree-item",
		components: {LinkCheckAll, LvScopeSlot, LvColumnText},
		mixins: [ColumnItemMixin],
		inject: {
			baseTable: {},
		},
		props: {
			intent: {type: Number, default: 8},
			showCheckbox: {type: Boolean},

			treeUtils: {type: Object},
		},
		computed: {
			tableNode() {
				if (!this.baseTable.treeConfig) {
					console.error('树列必须给table配置treeConfig对象属性')
				} else {
					const key = TableMark.generator.get(this.row, this.baseTable.treeConfig.keyField)
					return this.baseTable.mark.node.getByKey(key)
				}
			},
			contentStyles() {
				if (!this.tableNode) {
					return
				}
				return {
					paddingLeft: `${this.intent * (this.tableNode.level - 1)}px`
				}
			},
			classes() {
				return [
					'link-table-column-tree-item-content',
					{
						'link-table-column-tree-item-content-leaf': !this.tableNode ? true : this.tableNode.isLeaf,
						'link-table-column-tree-item-content-expanded': !this.tableNode ? false : this.tableNode.isExpand
					}
				]
			},
		}
	}
</script>

<style lang="scss">
	.link-table-column-tree-item-content {
		display: inline-flex;
		align-items: center;
		width: 100%;
		overflow: hidden;

		.link-table-column-tree-expand-icon {
			transform: rotate(-90deg);
		}

		&.link-table-column-tree-item-content-expanded {
			.link-table-column-tree-expand-icon {
				transform: rotate(0deg);
			}
		}

		&.link-table-column-tree-item-content-leaf {
			.link-table-column-tree-expand-icon {
				opacity: 0;
				pointer-events: none;
			}
		}

		.link-table-column-tree-item-text {
			flex: 1;
			flex-shrink: 0;
			overflow: hidden;
			white-space: nowrap;
		}
	}
</style>